import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = [
  /youtube\.com\/watch\?v=([^&]+)/,
  /youtube\.com\/embed\/([^&]+)/,
  /youtube\.com\/v\/([^&]+)/,
  /youtube\.com\/\?v=([^&]+)/,
  /youtu\.be\/([^&]+)/,
];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const id = useMemo(() => {
    // eslint-disable-next-line no-restricted-syntax
    for (const match of URL_REGEX) {
      const result = url.match(match);
      if (result) {
        return result[1];
      }
    }
    return null;
  }, [url]);

  if (!id) return <Typography color="error">Invalid YouTube URL</Typography>;

  return (
    <Portal
      url={`https://www.youtube.com/embed/${id}?modestbranding=1`}
      title="YouTube video player"
      aspectRatio="16 / 9"
      {...rest}
    />
  );
};

export default createEmbedExtension({
  regexp: URL_REGEX,
  name: 'youtube-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
  }),
  addCommandOption: {
    title: 'YouTube',
    description: 'Embed a YouTube video.',
    searchTerms: ['embed', 'youtube'],
    icon: 'tabler:brand-youtube',
  },
});
